export default __webpack_public_path__ + "static/media/mosquito.afb424b3.jpg";